import React from 'react'
import { Input, FormGroup } from 'reactstrap'

const ItemSelectableWithSwitch = ({ children, checked, onChange, disabled }) => {
    return (
        <div
            className='shadow-sm pt-3 ps-3 pe-3 pb-3 rounded-3 d-flex align-items-center justify-content-between'
            style={{ background: '#FFFF' }}
        >
            {children}
            <FormGroup switch>
                <Input type="switch" disabled={disabled} checked={checked} onChange={onChange} role="switch" />
            </FormGroup>
        </div>
    )
}

export default ItemSelectableWithSwitch